export const InputRequired = ({ renderIf = true }) => {
    if (!renderIf) return null;
    return <span className="text-brend ml-0.5">*</span>;
};
